import { CollectionResource } from 'dy-frontend-http-repository/lib/data/resources';
import {
    CreateTimeTrackingEntryInput,
    UpdateTimeTrackingEntryInput,
} from 'dy-frontend-http-repository/lib/modules/TimeTacking/inputs';
import TimeTrackingEntryFilterInput from 'dy-frontend-http-repository/lib/modules/TimeTacking/inputs/TimeTrackingEntriesFilterInput';
import { TimeTrackingEntryRef } from 'dy-frontend-http-repository/lib/modules/TimeTacking/refs';
import { TimeTrackingEntryResource } from 'dy-frontend-http-repository/lib/modules/TimeTacking/resources';
import repository from 'dy-frontend-http-repository/lib/repository';

import domain from './domain';

// Fetch work reports list
export const fetchWorkReports = domain.createEffect<
    { filter: TimeTrackingEntryFilterInput },
    CollectionResource<TimeTrackingEntryResource, {}>
>({
    name: 'fetchWorkReports',
    handler: async ({ filter }) => {
        return await repository.timeTracking().get(filter);
    },
});

// Create work report
export const createWorkReports = domain.createEffect<CreateTimeTrackingEntryInput, TimeTrackingEntryRef>({
    name: 'createWorkReports',
    handler: async (input) => {
        return await repository.timeTracking().create(input);
    },
});

// Update work report
export const updateWorkReport = domain.createEffect<
    { id: ID; input: UpdateTimeTrackingEntryInput },
    TimeTrackingEntryRef
>({
    name: 'updateWorkReport',
    handler: async ({ id, input }) => {
        return await repository.timeTracking().update(id, input);
    },
});

// Archive work report
export const removeWorkReport = domain.createEffect<ID, TimeTrackingEntryRef>({
    name: 'removeWorkReport',
    handler: async (entryId) => {
        return await repository.timeTracking().archive(entryId);
    },
});

// Restore work report
export const restoreWorkReport = domain.createEffect<ID, TimeTrackingEntryRef>({
    name: 'restoreWorkReport',
    handler: async (entryId) => {
        return await repository.timeTracking().restore(entryId);
    },
});
